<div class="row">
  <div class="left">
    <div class="chip" [ngClass]="{
      'red': type === 'Dropped',
      'green': type === 'Proxy',
      'yellow': type === 'Directly'
    }">
      {{type}}
    </div>
    <div class="text">{{name}}</div>
  </div>
  <div class="right">
    <app-pencil-two class="pencil" (click)="onEdit()"></app-pencil-two>
    <app-basket (click)="setDeleteModalOpened.emit(true)"></app-basket>
  </div>
</div> 